import * as React from "react";

function SvgSearch(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        d="M2.963 2.963a10.114 10.114 0 0114.034-.26 10.113 10.113 0 01.78 14.014l6.004 6.003a.75.75 0 01-1.061 1.06l-6.003-6.002A10.116 10.116 0 012.962 2.963zm7.141-1.473a8.614 8.614 0 000 17.228 8.623 8.623 0 008.614-8.614 8.614 8.614 0 00-8.614-8.614zm-1.57 2.25a.751.751 0 010 1.501 3.302 3.302 0 00-3.292 3.292.75.75 0 11-1.501 0 4.802 4.802 0 014.792-4.792z"
        fill="#8E8E93"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgSearch;
